import { buildApiUrl } from "../utils/apiConfig";
import { jsonGet, jsonSend } from "../utils/http";

export type ProgramVideoDto = {
    id: number;
    name: string;
    createdAt: string;
    videoUrl: string | null;
};

export type ProgramVideoPage = {
    content: ProgramVideoDto[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
};

export function fetchProgramVideos(
    pageZeroBased: number,
    pageSize: number,
    companyId?: number | null,
    nameContains?: string | null,
    forAthleteProfileId?: number | null
) {
    const params = new URLSearchParams();
    params.set("page", String(pageZeroBased));
    params.set("size", String(pageSize));
    if (companyId != null && companyId !== undefined) {
        params.set("companyId", String(companyId));
    }
    const trimmed = nameContains?.trim();
    if (trimmed) {
        params.set("nameContains", trimmed);
    }
    if (forAthleteProfileId != null && forAthleteProfileId !== undefined) {
        params.set("forAthleteProfileId", String(forAthleteProfileId));
    }
    return jsonGet<ProgramVideoPage>(`${buildApiUrl("api/program-videos")}?${params.toString()}`);
}

export function createProgramVideo(payload: { name: string; videoUrl: string; companyId?: number | null }) {
    return jsonSend<ProgramVideoDto>(buildApiUrl("api/program-videos"), "POST", {
        name: payload.name,
        videoUrl: payload.videoUrl,
        companyId: payload.companyId ?? null,
    });
}

export function updateProgramVideo(
    videoId: number,
    payload: {
        name: string;
        videoUrl: string;
    }
) {
    return jsonSend<ProgramVideoDto>(buildApiUrl(`api/program-videos/${videoId}`), "PATCH", payload);
}

export function deleteProgramVideo(videoId: number) {
    return jsonSend<void>(buildApiUrl(`api/program-videos/${videoId}`), "DELETE");
}

export function getProgramVideoPlaybackUrl(videoId: number, forAthleteProfileId?: number | null) {
    const params = new URLSearchParams();
    if (forAthleteProfileId != null && forAthleteProfileId !== undefined) {
        params.set("forAthleteProfileId", String(forAthleteProfileId));
    }
    const q = params.toString();
    const suffix = q ? `?${q}` : "";
    return jsonGet<{ url: string }>(buildApiUrl(`api/program-videos/${videoId}/playback-url${suffix}`));
}
